import React from "react";
import Loader from "../../../static/images/spinner.svg";

export const Spinner = ({ className, inline = false, }) => {
  return (
    <div className={inline ? className : `loader ${className ?? ""}`}>
      <img src={Loader} alt="loader" />
    </div>
  );
};
